import { PaymentFlowType } from '../constants/user-info/paymentFlowType';
import { apiService } from './apiService';
import { BillingType } from '../constants/user-info/billingType';

type GetPaymentFlowTypeResponse = { paymentFlowType: PaymentFlowType };

type BillingTypeSettings = {
  billingType: BillingType;
  scanIqBillingType: BillingType;
};

export const paymentService = {
  async getPaymentFlowType(entityId: number) {
    const resp = await apiService.get<GetPaymentFlowTypeResponse>(
      `api/entity/${entityId}/payment-flow`,
    );

    return resp.data;
  },

  async getBillingType(entityId: number) {
    const resp = await apiService.get<BillingTypeSettings>(
      `/api/entity/${entityId}/settings/billing-type`,
    );

    return resp.data;
  },

  async updateBillingType(entityId: number, payload: Partial<BillingTypeSettings>) {
    const resp = await apiService.put<BillingTypeSettings>(
      `/api/entity/${entityId}/settings/billing-type`,
      payload,
    );

    return resp.data;
  },
};
